/** 홈 전문가·HOT 목록과 채용 카드에서 같은 모양으로 쓰는 조회·관심 아이콘. */
export const EyeIcon = () => (
    <svg viewBox="0 0 24 24" aria-hidden="true" data-count-icon="view">
        <path d="M1.5 12S5.5 4.5 12 4.5 22.5 12 22.5 12 18.5 19.5 12 19.5 1.5 12 1.5 12z" />
        <circle cx="12" cy="12" r="3" />
    </svg>
);

export const HeartIcon = () => (
    <svg viewBox="0 0 24 24" aria-hidden="true" data-count-icon="favorite">
        <path d="M12 20.5s-8-4.9-8-10.6A4.4 4.4 0 0 1 12 7.3a4.4 4.4 0 0 1 8 2.6c0 5.7-8 10.6-8 10.6z" />
    </svg>
);
